module.exports = __webpack_public_path__ + "media/images/logo-b3423f2c.png";